import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getImageProps } from 'app/utilities/ImageProps';
import { Swiper, SwiperSlide } from 'swiper/react';
import './UpgradesPrivateArea.scss';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import { getReportParams, report } from '../../../middleware/report';


SwiperCore.use([Pagination, Navigation]);

const UpgradesPrivateArea = (props) => {
  const { iContent, context } = props;

  const [filterDataUpgrades,setFilterDataUpgrades] = useState();

  //Content evaluation information
  const mainTitle = iContent.mainTitle.value;
  const dataUpgrades = iContent.itemsUpgrades?.expandedValue?.map((x) => {
    const priText = x.priText.value;
    const secText = x.secText.value;
    const link = x.link.value;
    const subscriptionDisplay = x.subscriptionDisplay.value;
    const contactDisplay = x.contactDisplay.value;
    const businessDisplay = x.businessDisplay.value;
    const privateDisplay = x.privateDisplay.value;
    const unidentifiedDisplay = x.unidentifiedDisplay.value;
    const imageDes = getImageProps(x.imageDes, context);
    const imageMobile = getImageProps(x.imageMobile, context);
    const isBestSellerDisplay = x.bestSellerDisplay.value;
    const tagText = x.tagText.value;
    const tagBackgroundColor = x.tagBackgroundColor.value;
    const tagColor = x.tagColor.value;

    return {
      priText,
      secText,
      link,
      subscriptionDisplay,
      contactDisplay,
      privateDisplay,
      businessDisplay,
      unidentifiedDisplay,
      imageDes,
      imageMobile,
      isBestSellerDisplay,
      tagText,
      tagBackgroundColor,
      tagColor
    };
  });
  //Filter, which item to display, private or business and subscriber or contact
  useEffect(() => {
    const filterLoginUser = dataUpgrades?.filter((item) => {
      //Display of all items when the user is not logged in
      if (!props.isFetchLoginData) {
        return Boolean(item.unidentifiedDisplay);
      };
      const contactPerson = Boolean(props.userDetails.IsContactPerson || props.userDetails.IsPrimaryContact);
      const isBusinness = Boolean(props.subscribersByProduct?.Cellular?.[0]?.isBusinness);
      //Displaying items when the user is logged in according to closing the login
      return (
        (isBusinness && contactPerson && item.businessDisplay && item.contactDisplay) ||
        (isBusinness && !contactPerson && item.businessDisplay && item.subscriptionDisplay) ||
        (!isBusinness && contactPerson && item.privateDisplay && item.contactDisplay) ||
        (!isBusinness && !contactPerson && item.privateDisplay && item.subscriptionDisplay)
      );
    });
    setFilterDataUpgrades(filterLoginUser);
  }, [props.isFetchLoginData, props.userDetails, props.subscribersByProduct]);

  const showNavigation = filterDataUpgrades?.length > 3;




  const clickUpgrade = (e,item)=>{
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = `MyZone ${props.worldType} Lobby`;
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'UpSale Clicked';
    reportParams.param1 = item.priText ;
    report(reportParams);
    e.preventDefault();
    buildUrlAndOpenSameWindow(item.link)
  };

  return (
    <div className='upgrades-private-area'>
      {mainTitle && filterDataUpgrades?.length >= 1 && <h2 className='mainTitle' dangerouslySetInnerHTML={{ __html: mainTitle }}></h2>}
      <div className='wrapper-swiper-container'>
        {showNavigation &&<div className={'arrow-prev'}></div>}
        {filterDataUpgrades?.length >= 1 && (
          <div className='wrapper-swiper'>
            <Swiper
              className='swiper-item'
              navigation={showNavigation ? { nextEl: '.arrow-next', prevEl: '.arrow-prev' } : false}
              slidesPerView={'auto'}
              enabled={dataUpgrades.length >= 2}
              spaceBetween={20}
              breakpoints={{
                220: {
                  allowTouchMove: true,
                },
                1230:{
                  allowTouchMove: false,
                },
              }}
            >
              {filterDataUpgrades.map((item, i) => (
                <SwiperSlide key={i}>
                    <div className='square' onClick={(e) => clickUpgrade( e, item)}>
                    {item.imageDes.src && (
                      <div
                        className='background-image-desktop'
                        style={{ backgroundImage: `url(${item.imageDes.src})`}}
                      ></div>
                    )}
                    {item.imageMobile.src && (
                      <div
                        className='background-image-mobile'
                        style={{ backgroundImage: `url(${item.imageMobile.src})`}}
                      ></div>
                    )}
                    {item.isBestSellerDisplay && (
                      <div className='best-seller-display' style={{ backgroundColor: item.tagBackgroundColor, color: item.tagColor }}>
                        {item.tagText}
                      </div>
                    )}
                    <div className={`wrapper-text-square ${item.isBestSellerDisplay ? 'frame-spacing' : ''}`}>
                      <div className='text-square'>
                        {item.priText.length > 1 && <div dangerouslySetInnerHTML={{ __html: item.priText }}></div>}
                        {item.secText.length > 1 && <div className='sec-text' dangerouslySetInnerHTML={{ __html: item.secText }}></div>}
                      </div>
                      {item.link && (
                        <div className='wrapper-error' onClick={(e) => { e.preventDefault(); buildUrlAndOpenSameWindow(item.link) }}>
                          <p className='error'></p>
                        </div>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        {showNavigation&& <div className='arrow-next'></div>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscribersByProduct: state.selfcarePage?.subscribersByProduct,
    userDetails: state.authentication.loginData?.userDetails,
    isFetchLoginData: state.selfcarePage.isFetchLoginData,
    worldType: state.selfcarePage.epiData.worldType,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UpgradesPrivateArea);
